module.exports = "Select a crop area or a pre-configured aspect ratio and click “Apply”"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/CropImages/crop-images-how-to-step-three.md
// module id = 1150
// module chunks = 0